import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "src/shadcn/components/ui";

type Props = {
  ZONE_WISE_REBATES_DATA: any;
};

const ZonewiseRebates = ({ ZONE_WISE_REBATES_DATA }: Props) => {
  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <div className="w-3 h-3 bg-red-500 rounded-full"></div>
        <h3 className="text-lg font-semibold">Zone-wise Rebates</h3>
      </div>

      <Table>
        <TableHeader className="bg-slate-200">
          <TableRow>
            <TableHead className="font-semibold">ToD Zone</TableHead>
            <TableHead className="font-semibold text-center">Before MYT</TableHead>
            <TableHead className="font-semibold text-center">After MYT</TableHead>
            <TableHead className="font-semibold text-center">Change</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {ZONE_WISE_REBATES_DATA.map((row: any, index: number) => (
            <TableRow key={index}>
              <TableCell className="font-medium">{row.parameter}</TableCell>
              <TableCell className="text-center text-sm">{row.beforeMYT}</TableCell>
              <TableCell className="text-center text-sm max-w-xs">{row.afterMYT}</TableCell>
              <TableCell className="text-center text-red-600 font-medium text-sm">{row.change}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ZonewiseRebates;
